import React, { Suspense, useMemo } from "react";
import { Canvas } from "@react-three/fiber";
import { useTheme } from '../ThemeProvider'
import { Float, PresentationControls, Html, ContactShadows } from "@react-three/drei";
import GltfModel from "./GltfModel";

const Avatar = (props) => {
  const { theme } = useTheme();
  const isDarkMode = useMemo(() => theme==='dark', [theme])
  return (
    <Canvas
    camera={ {
      fov: 45,
      near: 0.1,
      far: 2000,
      position: [ 10, 0, 20 ]
  } }
    >
      <ambientLight intensity={0.3} />
      <pointLight position={[0, 0, 0]} intensity={0.5} />
      <PresentationControls
        global
        rotation={[0, 0, 0]}
        polar={[-0.48, 0.48]}
        azimuth={[-0.68, 0.68]}
        config={{ mass: 2, tension: 400 }}
        snap={{ mass: 4, tension: 400 }}
      >
      <Float rotationIntensity={1.2}>
        <Suspense fallback={null}>
          <GltfModel modelPath={'./model/painting.glb'} scale={2.6} position={[-1,-3,-1.8]}>
          <Html
              transform
              wrapperClass="htmlScreen"
              occlude
              prepend
              distanceFactor={2.4}
              position={[0,1,0.015]}
            >
              <img src='https://avatars.githubusercontent.com/u/29631279?v=4' alt='avatar' className="avatar-img"></img>
            </Html>
          </GltfModel>
          </Suspense>
      </Float>
      </PresentationControls>
      <ContactShadows position-y={-4} opacity={0.8} scale={10} blur={10} color={isDarkMode?'#fff':'#000'}/>
    </Canvas>
  );
};

export default Avatar;